export const BODY_FIGURE_TEXTS: { [key: string] : string } = {
  SKINNY: '痩せている',
  THIN: '細め',
  NORMAL: '普通',
  THICK: 'がっちり',
  FAT: '太め'
}

export const AREA_TEXTS: { [key: string] : string } = {
  HOKKAIDO: '北海道',
  AOMORI: '青森',
  IWATE: '岩手',
  MIYAGI: '宮城',
  AKITA: '秋田',
  YAMAGATA: '山形',
  FUKUSHIMA: '福島',
  TOKYO: '東京',
  KANAGAWA: '神奈川',
  CHIBA: '千葉',
  SAITAMA: '埼玉',
  IBARAK: '茨城',
  TOCHIGI: '栃木',
  GUNMA: '群馬',
  NIIGATA: '新潟',
  TOYAMA: '富山',
  ISHIKAWA: '石川',
  FUKUI: '福井',
  YAMANASHI: '山梨',
  NAGANO: '長野',
  GIFU: '岐阜',
  SHIZUOKA: '静岡',
  AICHI: '愛知',
  MIE: '三重',
  OSAKA: '大阪',
  HYOGO: '兵庫',
  KYOTO: '京都',
  SHIGA: '滋賀',
  NARA: '奈良',
  WAKAYAMA: '和歌山',
  TOTTORI: '鳥取',
  SHIMANE: '島根',
  OKAYAMA: '岡山',
  HIROSHIMA: '広島',
  YAMAGUCHI: '山口',
  TOKUSHIMA: '徳島',
  KAGAWA: '香川',
  EHIME: '愛媛',
  KOCHI: '高知',
  FUKUOKA: '福岡',
  SAGA: '佐賀',
  NAGASAKI: '長崎',
  KUMAMOTO: '熊本',
  OITA: '大分',
  MIYAZAKI: '宮崎',
  KAGOSHIMA: '鹿児島',
  OKINAWA: '沖縄'
}

export const COLLEGE_TYPE_TEXTS: { [key: string] : string } = {
  PUBLIC: '国公立大学',
  PRIVATE: '私立大学',
  HIGHSCHOOL: '高等学校',
  OTHER: 'その他'
}

export const MAJOR_TYPE_TEXTS: { [key: string] : string } = {
  BS: '理系',
  BA: '文系',
  OTHER: 'その他'
}

export const MARRIAGE_TEXTS: { [key: string] : string } = {
  UNMARRIED: '未婚',
  MARRIED: '既婚',
  DIVORCED: '離婚'
}

export const METHOD_TEXTS: { [key: string] : string } = {
  SYRINGE: 'シリンジ法',
  TIMING: 'タイミング法'
}

export const RECORD_STATUS_TEXTS: { [key: string] : string } = {
  PENDING: '承認待ち',
  APPROVED: '承認済み',
  REJECTED: '拒否',
}

export const KYC_STATUS_FOR_USER_TEXTS: { [key: string] : string } = {
  DRAFT: '未提出',
  SUBMITTED: '提出済み',
  AUTO_CERTIFIED: '承認済み',
  PENDING: '承認待ち',
  MAN_CERTIFIED: '承認済み',
  REMANDED: '要修正'
}

export const KYC_TYPE_TEXTS: { [key: string] : string } = {
  DRIVER_LICENSE: '運転免許証',
  MYNUMBER: 'マイナンバーカード',
  PASSPORT: 'パスポート',
  RESIDENCE_CARD: '在留カード',
}

export const NATIONALITY_TEXTS: { [key: string] : string } = {
  JAPANESE: '日本',
  OTHER: '日本以外'
}

export const RACE_TEXTS: { [key: string] : string } = {
  JAPANESE: '日本人',
  EAST_ASIAN: '東アジア',
  OTHER_ASIAN: '他のアジア',
  CAUCASIAN: '白人系',
  AFRICAN: 'アフリカ系',
  HISPANIC: 'ヒスパニック系',
  MIXED: '混血',
  OTHER: 'その他'
}

export const HAIR_TYPE_TEXTS: { [key: string] : string } = {
  STRAIGHT: '直毛',
  WAVY: 'クセ毛',
  SOFT: '軟毛',
  HARD: '硬毛',
  COARSE: '剛毛'
}

export const HAIR_COLOR_TEXTS: { [key: string] : string } = {
  BLACK: '黒色',
  DARK_BROWN: '濃い茶色',
  LIGHT_BROWN: '薄い茶色',
  OTHER: 'その他'
}

export const EYELID_TEXTS: { [key: string] : string } = {
  SINGLE: '一重',
  HOODED: '奥二重',
  DOUBLE: '二重'
}

export const TRAVEL_EXPENSES_TEXTS: { [key: string] : string } = {
  DONOR_PAYS: 'ドナー負担',
  DONEE_PAYS: 'ドニー負担',
  SPLIT: '割り勘'
}

export const IDENTITY_DISCLOSURE_TEXTS: { [key: string] : string } = {
  AVAILABLE: '可',
  UNAVAILABLE: '不可（匿名）'
}

export const CERTIFICATE_PRESENTATION_TEXTS: { [key: string] : string } = {
  AVAILABLE: '可',
  UNAVAILABLE: '不可'
}

export const ORIGIN_RIGHT_TEXTS: { [key: string] : string } = {
  AVAILABLE: '対応可',
  UNAVAILABLE: '対応不可'
}

export const AGE_RANGE_TEXTS: { [key: string]: string } = {
  TWENTIES: '20代',
  THIRTIES: '30代',
  FORTIES: '40代',
  FIFTIES_PLUS: '50代以上',
}

export const HEIGHT_RANGE_TEXTS: { [key: string]: string } = {
  UNDER160: '〜160cm',
  H160TO170: '160cm〜170cm',
  H170TO180: '170cm〜180cm',
  OVER180: '180cm〜',
}

export const FORUM_STATUS_TEXTS: { [key: string]: string } = {
  DRAFT: '下書き',
  OPEN: '公開中',
}
